module.exports = __webpack_public_path__ + "static/media/4lg.42e06450.jpg";